export default __webpack_public_path__ + "static/media/418.7c61891d.png";